/**
 * Guarded service-worker registration.
 *
 * Offline support is a core promise of Trades Toolbelt, but the worker must
 * never run inside the Lovable editor preview or dev server, where it would
 * serve stale HTML and deleted chunks.
 */
const SW_URL = "/sw.js";

function isPreviewHost(host: string) {
  return (
    host.startsWith("id-preview--") ||
    host.startsWith("preview--") ||
    host === "lovableproject.com" ||
    host.endsWith(".lovableproject.com") ||
    host === "lovableproject-dev.com" ||
    host.endsWith(".lovableproject-dev.com") ||
    host === "beta.lovable.dev" ||
    host.endsWith(".beta.lovable.dev")
  );
}

async function unregisterAppWorker() {
  if (!("serviceWorker" in navigator)) return;
  const regs = await navigator.serviceWorker.getRegistrations();
  await Promise.allSettled(
    regs
      .filter((r) => (r.active?.scriptURL || r.installing?.scriptURL || "").endsWith(SW_URL))
      .map((r) => r.unregister()),
  );
}

export function registerServiceWorker() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;

  const inIframe = window.self !== window.top;
  const killSwitch = new URLSearchParams(window.location.search).get("sw") === "off";
  // Native builds ship every file inside the app bundle — a worker adds nothing
  // but a stale-cache risk.
  const isNative = Boolean((window as any).Capacitor?.isNativePlatform?.());
  const blocked =
    !import.meta.env.PROD ||
    inIframe ||
    killSwitch ||
    isNative ||
    isPreviewHost(window.location.hostname);


  if (blocked) {
    void unregisterAppWorker();
    return;
  }

  window.addEventListener("load", () => {
    void navigator.serviceWorker.register(SW_URL, { scope: "/" });
  });
}
